import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container px-0" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-lg-10 mx-auto" }
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = {
  key: 1,
  class: "pb-10 pb-lg-12"
}
const _hoisted_6 = { class: "d-flex flex-column flex-lg-row justify-content-between align-items-lg-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold d-flex align-items-center text-dark" }, [
    /*#__PURE__*/_createTextVNode(" Provide applicant details. "),
    /*#__PURE__*/_createElementVNode("i", {
      class: "fas fa-exclamation-circle ms-2 fs-7",
      "data-bs-toggle": "tooltip",
      title: "Billing is issued based on your selected account type"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-semobold fs-6" }, [
    /*#__PURE__*/_createTextVNode(" If you need more info, please check out "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "link-primary fw-bold"
    }, "Help Page"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_8 = { class: "d-flex gap-3 mt-lg-0 mt-6" }
const _hoisted_9 = { class: "svg-icon svg-icon-2" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Add Applicant ")
const _hoisted_11 = { class: "card-body pt-0" }
const _hoisted_12 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_13 = ["value"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Edit ")
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Delete ")
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("View ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActiveSubscriptionCard = _resolveComponent("ActiveSubscriptionCard")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_ExcelParser = _resolveComponent("ExcelParser")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_ApplicantModal = _resolveComponent("ApplicantModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.activeSubscription)
              ? (_openBlock(), _createBlock(_component_ActiveSubscriptionCard, {
                  key: 0,
                  class: "mb-4",
                  subscription: _ctx.activeSubscription,
                  note: `Via your active subscription, you have ${_ctx.remainingVerifications} verifications left`,
                  active: _ctx.isSubscriptionSelected,
                  onSelected: _ctx.selectSubscription
                }, null, 8, ["subscription", "note", "active", "onSelected"]))
              : _createCommentVNode("", true),
            (!_ctx.isReview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-success me-3",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#kt_modal_add_applicant",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addRecord($event)))
                      }, [
                        _createElementVNode("span", _hoisted_9, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Plus.svg" })
                        ]),
                        _hoisted_10
                      ]),
                      _createVNode(_component_ExcelParser, {
                        "upload-help-text": "Upload an excel sheet containing information of your applicants",
                        "upload-critical-text": "Ensure your sheet contains columns for First Name, Last Name, Email and Date Of Birth",
                        "required-cols": ['First Name', 'Last Name', 'Email'],
                        "example-sheet": _ctx.applicantUploadSheetUrl,
                        onChange: _ctx.bulkAddRecords
                      }, null, 8, ["example-sheet", "onChange"])
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (field, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: field.id
                    }, [
                      _createVNode(_component_Field, {
                        style: {"display":"none"},
                        name: `applicants[${idx}]`,
                        modelValue: _ctx.tableData[idx],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.tableData[idx]) = $event),
                        class: "form-control form-control-lg form-control-solid"
                      }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: `applicants[${idx}].first_name`,
                        class: "fv-plugins-message-container invalid-feedback"
                      }, null, 8, ["name"]),
                      _createVNode(_component_ErrorMessage, {
                        name: `applicants[${idx}].last_name`,
                        class: "fv-plugins-message-container invalid-feedback"
                      }, null, 8, ["name"]),
                      _createVNode(_component_ErrorMessage, {
                        name: `applicants[${idx}].email`,
                        class: "fv-plugins-message-container invalid-feedback"
                      }, null, 8, ["name"])
                    ]))
                  }), 128)),
                  _createVNode(_component_ErrorMessage, {
                    name: "applicants",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              (_ctx.tableData.length > 0)
                ? (_openBlock(), _createBlock(_component_Datatable, {
                    key: 0,
                    "table-data": _ctx.tableData,
                    "table-header": _ctx.tableHeader,
                    "enable-items-per-page-dropdown": true,
                    total: _ctx.tableData.length,
                    emptyTableText: 'Please add applicants'
                  }, {
                    "cell-checkbox": _withCtx(({ row: customer }) => [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          value: customer.id
                        }, null, 8, _hoisted_13)
                      ])
                    ]),
                    "cell-first_name": _withCtx(({ row: customer }) => [
                      _createTextVNode(_toDisplayString(customer.first_name), 1)
                    ]),
                    "cell-last_name": _withCtx(({ row: customer }) => [
                      _createTextVNode(_toDisplayString(customer.last_name), 1)
                    ]),
                    "cell-email": _withCtx(({ row: customer }) => [
                      _createTextVNode(_toDisplayString(customer.email), 1)
                    ]),
                    "cell-date_of_birth": _withCtx(({ row: customer }) => [
                      _createTextVNode(_toDisplayString(customer.date_of_birth), 1)
                    ]),
                    "cell-edit": _withCtx(({ row: customer }) => [
                      (!_ctx.isReview)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _withModifiers(($event: any) => (_ctx.editRecord(customer.id, $event)), ["stop"]),
                            class: "btn btn-sm btn-light btn-active-light-primary m-1",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#kt_modal_add_applicant"
                          }, [
                            _createElementVNode("span", _hoisted_15, [
                              _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com011.svg" })
                            ]),
                            _hoisted_16
                          ], 8, _hoisted_14))
                        : _createCommentVNode("", true),
                      (!_ctx.isReview)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            onClick: ($event: any) => (_ctx.deleteRecord(customer.id, $event)),
                            class: "btn btn-sm btn-light btn-active-light-primary m-1"
                          }, [
                            _createElementVNode("span", _hoisted_18, [
                              _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com011.svg" })
                            ]),
                            _hoisted_19
                          ], 8, _hoisted_17))
                        : _createCommentVNode("", true),
                      (_ctx.isReview)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            onClick: _withModifiers(($event: any) => (_ctx.editRecord(customer.id, $event)), ["stop"]),
                            class: "btn btn-sm btn-light btn-active-light-primary m-1",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#kt_modal_add_applicant"
                          }, [
                            _createElementVNode("span", _hoisted_21, [
                              _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com011.svg" })
                            ]),
                            _hoisted_22
                          ], 8, _hoisted_20))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["table-data", "table-header", "total"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_ApplicantModal, {
      isReview: _ctx.isReview,
      rowId: _ctx.currentRowId,
      existingData: _ctx.selectedRow,
      "aml-plans": _ctx.amlPlans,
      onApplicantUpdate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onApplicantUpdate($event)))
    }, null, 8, ["isReview", "rowId", "existingData", "aml-plans"])
  ], 64))
}